import { all } from "redux-saga/effects";
/*
import ProductFilter from "./ProductFilterSaga";
*/

export default function* rootSaga() {
    yield all([
       /* ProductFilter()*/
    ]);
}